export default function fileName() {
    const fileContainers = document.querySelectorAll(".contact__file");

    fileContainers.forEach(container => {
        const inputFile = container.querySelector("input[type='file']");
        
        let fileNameDisplay = container.querySelector("span.file");
        
        if (!fileNameDisplay) {
            const allSpans = container.querySelectorAll("span");
            allSpans.forEach(span => {
                if (!span.contains(inputFile) && !span.classList.contains('wpcf7-form-control-wrap')) {
                    fileNameDisplay = span;
                }
            });
        }

        if (inputFile && fileNameDisplay) {
            inputFile.addEventListener("change", (event) => {
                if (event.target.files.length > 0) {
                    fileNameDisplay.textContent = event.target.files[0].name;
                } else {
                    fileNameDisplay.textContent = "";
                }
            });
        }
    });
}
